/***************************************************************************************************
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves.
 *
 * The app runs without zone.js: change detection is scheduled by signals, template events and the
 * other Angular APIs listed in the zoneless guide.
 *
 * Learn more in https://angular.dev/reference/versions
 */

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
import 'url-polyfill';
